// extracted by mini-css-extract-plugin
export default {"list":"styles_list__GMbqC","listModal":"styles_listModal__A8Nca","listItemModal":"styles_listItemModal__yBvZK"};